'use client';

import styles from './archival-label.module.scss';
import RedundantLink from 'components/accesibility/redundant-link';
import NoImage from 'components/helper/no-image';
import { Link } from 'src/navigation';
import type { IObjectAsLauderArchivalLabel } from '@metmuseum/types';
import LegacyOrMarkdownParser from 'components/rich-text/legacy-or-markdown-parser';

interface IProps {
	enforceMaxWidth?: boolean;

	handleObjectClick: (e: unknown, index: number) => void;
	index?: number;
	archivalLabel: IObjectAsLauderArchivalLabel;
	lazyLoad?: boolean;
}

export const ArchivalLabelCard = ({
	archivalLabel,
	handleObjectClick,
	index,
	enforceMaxWidth = false,
	lazyLoad = true,
}: IProps) => {
	const hasImage =
		archivalLabel?.image && !archivalLabel?.image.includes('NoImage');
	return (
		<figure
			className={`${styles.archivalLabel} playwright-archival-label-card`}
		>
			<div className={styles.imageWrapper}>
				<RedundantLink
					href={'#'}
					onClick={(e) => handleObjectClick(e, index)}
				/>
				{hasImage ? (
					/* eslint-disable @next/next/no-img-element */
					<img
						loading={lazyLoad ? 'lazy' : 'eager'}
						className={`${styles.image} ${enforceMaxWidth && styles.gridView}`}
						src={archivalLabel.image}
						alt={archivalLabel.imageAlt}
					/>
				) : (
					/* eslint-enable @next/next/no-img-element */
					<NoImage />
				)}
			</div>
			<figcaption className={styles.caption}>
				<div className={styles.title}>
					<Link
						onClick={(e) => handleObjectClick(e, index)}
						className={styles.link}
						href={'#'}
						title={archivalLabel.title}
					>
						<LegacyOrMarkdownParser>
							{archivalLabel.title}
						</LegacyOrMarkdownParser>
					</Link>
				</div>
			</figcaption>
		</figure>
	);
};
